<template>
  <v-text-field
    v-model="password"
    class="mm-input pb-3"
    color="blue darken-1"
    :hide-details="$attrs['hide-details'] || true"
    :rules="rules"
    ref="password"
    :type="showPass ? 'text' : 'password'"
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
  >
    <template #append>
      <v-icon @click="showPass = !showPass">{{
        showPass ? 'mdi-eye' : 'mdi-eye-off'
      }}</v-icon>
    </template>
  </v-text-field>
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
export default {
  name: 'PasswordField',
  props: {
    rules: {
      type: [String, Array],
      default: () => [ValidationRules.requiredString],
    },
  },
  components: {},
  data() {
    return {
      showPass: false,
      password: '',
      ValidationRules,
    }
  },
}
</script>
